import { useCallback } from 'react';
import * as consentService from '../services/consentService';
import {
  ICreateConsentRequestInput,
  IRevokeConsentInput,
  IRespondConsentInput,
} from '../types/interfaces/IConsent';

export function useConsents() {
  const createConsent = useCallback(async (payload: ICreateConsentRequestInput) => {
    return await consentService.createConsent(payload);
  }, []);

  const getConsentById = useCallback(async (consentId: string) => {
    return await consentService.getConsentById(consentId);
  }, []);

  const getAllConsents = useCallback(
    async (filters: {
      institutionId: string;
      status?: string;
      partyStatus?: string;
      partyType?: string;
      from?: string;
      to?: string;
    }) => {
      return await consentService.getConsents(filters);
    },
    []
  );

  const respondConsent = useCallback(
    async (consentId: string, payload: IRespondConsentInput) => {
      return await consentService.respondConsent(consentId, payload);
    },
    []
  );

  const revokeConsent = useCallback(async (consentId: string, payload?: IRevokeConsentInput) => {
    return await consentService.revokeConsent(consentId, payload);
  }, []);

  return {
    createConsent,
    getConsentById,
    getAllConsents,
    respondConsent,
    revokeConsent,
  };
}
